var urlRegex =/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
var wwwUrlRegex = /(^www\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/igm

function urlify ({ string }) {

  var textModified
  textModified = string.replaceAll(wwwUrlRegex, (url) => {
    return url.replaceAll('www.', 'https://')
  })
  textModified = textModified.replaceAll(urlRegex, (url) => {
    return `<a href="${ url }" target="_blank">${ url }</a>`
  })
  return textModified
}

export {
  urlify,
}